<template>
    <app-model :class="{ 'show': show }" size="modal-xl">
        <template v-slot:header class="modal-header d-flex align-items-center">
          <button type="button" @click="$emit('onClear')" class="btn-close"></button>
        </template>
        <template v-slot:body class="modal-body">
            <app-rating :data="data" @onClear="$emit('onClear')"></app-rating>
        </template>
    </app-model>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalRating.vue